module.exports = __webpack_public_path__ + "img/marshdream.37b83466.jpeg";